<!-- @todo: Extension service check to be added -->
<div class="insights-page" *ngIf="preLoader" style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
  ">
  <div class="section-body insights-body">

    <!-- Header skeleton -->
    <div class="insights-header-enhanced">
      <div class="header-content-enhanced" style="padding: 20px 24px;">
        <div class="header-main-section">
          <div class="header-title-section">
            <p-skeleton shape="circle" size="3rem" styleClass="mr-3"></p-skeleton>
            <div class="header-title-content">
              <p-skeleton width="240px" height="22px" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="140px" height="13px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- KPI grid skeleton -->
    <div class="kpi-grid-compact">
      <div class="kpi-card-compact" *ngFor="let card of [1,2,3,4]">
        <div class="kpi-header-compact">
          <p-skeleton shape="circle" size="2rem"></p-skeleton>
        </div>
        <p-skeleton width="50%" height="26px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="70%" height="12px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="100%" height="6px"></p-skeleton>
      </div>
    </div>

    <!-- Section 1: staggered insight cards skeleton -->
    <div class="insight-section">
      <p-skeleton width="220px" height="18px" styleClass="mb-3"></p-skeleton>
      <div class="staggered-grid">
        <div class="insight-card-staggered insight-card-large">
          <p-skeleton width="160px" height="14px" styleClass="mb-3"></p-skeleton>
          <p-skeleton width="70%" height="20px" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="90%" height="12px"></p-skeleton>
        </div>
        <div class="insight-card-staggered insight-card-medium" *ngFor="let card of [1,2]">
          <p-skeleton width="140px" height="14px" styleClass="mb-3"></p-skeleton>
          <p-skeleton width="70%" height="20px" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="90%" height="12px"></p-skeleton>
        </div>
        <div class="insight-card-staggered insight-card-small">
          <p-skeleton width="100px" height="14px" styleClass="mb-3"></p-skeleton>
          <p-skeleton width="70%" height="20px" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="90%" height="12px"></p-skeleton>
        </div>
      </div>
    </div>

    <!-- Section 2: chart + feature cards skeleton -->
    <div class="insight-section">
      <p-skeleton width="260px" height="18px" styleClass="mb-3"></p-skeleton>
      <div class="chart-row-wrapper">
        <div class="chart-card-full">
          <p-skeleton width="200px" height="16px" styleClass="mb-3"></p-skeleton>
          <div class="chart-container-compact chart-container-horizontal">
            <p-skeleton width="100%" height="100%"></p-skeleton>
          </div>
        </div>
      </div>
      <div class="kpi-cards-grid">
        <div class="feature-card" *ngFor="let card of [1,2,3,4]">
          <div class="feature-card-content">
            <div class="feature-card-header">
              <p-skeleton shape="circle" size="2.2rem" styleClass="mr-2"></p-skeleton>
              <div class="feature-header-text">
                <p-skeleton width="150px" height="14px" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="180px" height="11px"></p-skeleton>
              </div>
            </div>
            <div class="feature-card-body">
              <p-skeleton width="100%" height="14px" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="100%" height="14px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 4: attendance pattern cards skeleton -->
    <div class="insight-section">
      <p-skeleton width="200px" height="18px" styleClass="mb-3"></p-skeleton>
      <div class="staggered-grid attendance-patterns-grid">
        <div class="attendance-pattern-card" *ngFor="let card of [1,2,3]">
          <p-skeleton shape="circle" size="2rem" styleClass="mb-3"></p-skeleton>
          <p-skeleton width="80px" height="20px" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="12px"></p-skeleton>
        </div>
      </div>
    </div>

    <!-- Section 5: risk cards skeleton -->
    <div class="insight-section">
      <p-skeleton width="180px" height="18px" styleClass="mb-3"></p-skeleton>
      <div class="risk-grid-modern">
        <div class="risk-card-modern" *ngFor="let card of [1,2,3]">
          <p-skeleton width="140px" height="14px" styleClass="mb-3"></p-skeleton>
          <p-skeleton width="100%" height="14px" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="14px" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="8px"></p-skeleton>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="insights-page" *ngIf="!preLoader" style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
  ">
        <div class="section-body insights-body">
          
          <!-- Enhanced AI Insights Header -->
          <div class="insights-header-enhanced">
            <div class="header-pattern"></div>
            <div class="header-content-enhanced">
              <div class="header-main-section">
                <div class="header-title-section">
                  <div class="header-icon-enhanced">
                    <i class="fa fa-lightbulb-o"></i>
                  </div>
                  <div class="header-title-content">
                    <h1 class="page-title-enhanced">{{ 'aiInsights.aiInsightsDashboard' | translate }}</h1>
                    <p class="page-subtitle-enhanced">{{ schoolName }}</p>
                  </div>
                </div>
                <div class="header-timestamp-section">
                  <div class="data-timestamp-enhanced">
                    <i class="fa fa-clock-o"></i>
                    <span>{{ 'aiInsights.lastUpdated' | translate }}: {{ dataGeneratedAt }}</span>
                  </div>
                </div>
              </div>
              
              <div class="header-benefits-section">
                <div class="benefits-list">
                  <div class="benefit-item">
                    <i class="fa fa-check-circle"></i>
                    <span>{{ 'aiInsights.realTimeAnalytics' | translate }}</span>
                  </div>
                  <div class="benefit-item">
                    <i class="fa fa-check-circle"></i>
                    <span>{{ 'aiInsights.earlyRiskIdentification' | translate }}</span>
                  </div>
                  <div class="benefit-item">
                    <i class="fa fa-check-circle"></i>
                    <span>{{ 'aiInsights.dataDrivenDecisions' | translate }}</span>
                  </div>
                  <div class="benefit-item">
                    <i class="fa fa-check-circle"></i>
                    <span>{{ 'aiInsights.actionableInsights' | translate }}</span>
                  </div>
                </div>
              </div>
              
              <div class="header-privacy-section">
                <div class="privacy-badge">
                  <i class="fa fa-shield"></i>
                  <span>{{ 'aiInsights.privacyMessage' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="data-warning-enhanced">
              <i class="fa fa-info-circle"></i>
              <span>{{ 'aiInsights.dataAccuracyNote' | translate }}</span>
            </div>
          </div>

          <!-- Main KPI Grid - Compact -->
          <div class="kpi-grid-compact">
            <div class="kpi-card-compact kpi-primary-compact">
              <div class="kpi-header-compact">
                <div class="kpi-icon-compact">
                  <i class="fa fa-check-circle"></i>
                </div>
                <div class="kpi-info-icon-compact">
                  <div class="info-tooltip" 
                       [attr.data-tooltip]="insightMetadata['homework_completion']?.insightDisclaimerMessage || ('aiInsights.homeworkCompletionDesc' | translate)"
                       (mouseenter)="showTooltip($event)"
                       (mouseleave)="hideTooltip($event)">
                    <i class="fa fa-info-circle"></i>
                  </div>
                </div>
              </div>
              <div class="kpi-value-compact">{{ overallHomeworkCompletionRate }}%</div>
              <div class="kpi-label-compact">{{ insightMetadata['homework_completion']?.insightName || ('aiInsights.homeworkCompletion' | translate) }}</div>
              <div class="kpi-info-text">{{ insightMetadata['homework_completion']?.insightDescription || ('aiInsights.homeworkCompletionDesc' | translate) }}</div>
              <div class="kpi-progress">
                <div class="kpi-progress-bar" [style.width.%]="overallHomeworkCompletionRate"></div>
              </div>
            </div>

            <div class="kpi-card-compact kpi-success-compact">
              <div class="kpi-header-compact">
                <div class="kpi-icon-compact">
                  <i class="fa fa-users"></i>
                </div>
                <div class="kpi-info-icon-compact">
                  <div class="info-tooltip" 
                       [attr.data-tooltip]="insightMetadata['attendance_rate']?.insightDisclaimerMessage || ('aiInsights.attendanceRateDesc' | translate)"
                       (mouseenter)="showTooltip($event)"
                       (mouseleave)="hideTooltip($event)">
                    <i class="fa fa-info-circle"></i>
                  </div>
                </div>
              </div>
              <div class="kpi-value-compact">{{ overallAttendanceRate }}%</div>
              <div class="kpi-label-compact">{{ insightMetadata['attendance_rate']?.insightName || ('aiInsights.attendanceRate' | translate) }}</div>
              <div class="kpi-info-text">{{ insightMetadata['attendance_rate']?.insightDescription || ('aiInsights.attendanceRateDesc' | translate) }}</div>
              <div class="kpi-progress">
                <div class="kpi-progress-bar" [style.width.%]="overallAttendanceRate"></div>
              </div>
            </div>

            <div class="kpi-card-compact kpi-info-compact">
              <div class="kpi-header-compact">
                <div class="kpi-icon-compact">
                  <i class="fa fa-star"></i>
                </div>
                <div class="kpi-info-icon-compact">
                  <div class="info-tooltip" 
                       [attr.data-tooltip]="insightMetadata['high_engagement']?.insightDisclaimerMessage || ('aiInsights.highEngagementDesc' | translate)"
                       (mouseenter)="showTooltip($event)"
                       (mouseleave)="hideTooltip($event)">
                    <i class="fa fa-info-circle"></i>
                  </div>
                </div>
              </div>
              <div class="kpi-value-compact">{{ highEngagementStudentRatio }}%</div>
              <div class="kpi-label-compact">{{ insightMetadata['high_engagement']?.insightName || ('aiInsights.highEngagement' | translate) }}</div>
              <div class="kpi-info-text">{{ insightMetadata['high_engagement']?.insightDescription || ('aiInsights.highEngagementDesc' | translate) }}</div>
              <div class="kpi-progress">
                <div class="kpi-progress-bar" [style.width.%]="highEngagementStudentRatio"></div>
              </div>
            </div>

            <div class="kpi-card-compact kpi-warning-compact">
              <div class="kpi-header-compact">
                <div class="kpi-icon-compact">
                  <i class="fa fa-exclamation-triangle"></i>
                </div>
                <div class="kpi-info-icon-compact">
                  <div class="info-tooltip" 
                       [attr.data-tooltip]="insightMetadata['low_engagement']?.insightDisclaimerMessage || ('aiInsights.lowEngagementDesc' | translate)"
                       (mouseenter)="showTooltip($event)"
                       (mouseleave)="hideTooltip($event)">
                    <i class="fa fa-info-circle"></i>
                  </div>
                </div>
              </div>
              <div class="kpi-value-compact">{{ lowEngagementStudentRatio }}%</div>
              <div class="kpi-label-compact">{{ insightMetadata['low_engagement']?.insightName || ('aiInsights.lowEngagement' | translate) }}</div>
              <div class="kpi-info-text">{{ insightMetadata['low_engagement']?.insightDescription || ('aiInsights.lowEngagementDesc' | translate) }}</div>
              <div class="kpi-progress">
                <div class="kpi-progress-bar warning" [style.width.%]="lowEngagementStudentRatio"></div>
              </div>
            </div>
          </div>

          <!-- Staggered Insights Layout -->
          <div class="staggered-insights-container">
            
            <!-- Section 1: Class Performance Insights -->
            <div class="insight-section">
              <div class="section-title-wrapper">
                <h2 class="section-title-main">
                  <i class="fa fa-graduation-cap"></i>
                  {{ 'aiInsights.classPerformanceInsights' | translate }}
                </h2>
                <p class="section-subtitle">{{ 'aiInsights.classPerformanceSubtitle' | translate }}</p>
              </div>
              
              <div class="staggered-grid">
                <div class="insight-card-staggered insight-card-large insight-success-compact">
                  <div class="insight-header-compact">
                    <i class="fa fa-trophy"></i>
                    <span>{{ insightMetadata['most_regular_class']?.insightName || ('aiInsights.bestPerformingClass' | translate) }}</span>
                    <div class="info-tooltip" 
                         [attr.data-tooltip]="insightMetadata['most_regular_class']?.insightDisclaimerMessage || ('aiInsights.bestPerformingClassDesc' | translate)"
                         (mouseenter)="showTooltip($event)"
                         (mouseleave)="hideTooltip($event)">
                      <i class="fa fa-info-circle"></i>
                    </div>
                  </div>
                  <div class="insight-content-compact">
                    <div class="classes-list-container" *ngIf="mostRegularClass.length > 0; else noRegularClass">
                      <div class="class-item-main" *ngFor="let classItem of mostRegularClass.slice(0, 2); let i = index">
                        <div class="insight-main-value-compact">{{ classItem.name }}</div>
                        <div class="insight-metric-compact">
                          <span class="metric-badge">{{ classItem.attendance | number:'1.2-2' }}%</span>
                          <span class="metric-label-compact">{{ 'aiInsights.attendanceRateLabel' | translate }}</span>
                        </div>
                      </div>
                      <div class="more-classes-indicator" *ngIf="mostRegularClass.length > 2" 
                           [attr.data-count]="mostRegularClass.length - 2"
                           (mouseenter)="showClassesTooltip($event, mostRegularClass, 'attendance')"
                           (mouseleave)="hideClassesTooltip($event)">
                        <span class="more-text">+{{ mostRegularClass.length - 2 }} {{ mostRegularClass.length - 2 > 1 ? ('aiInsights.others' | translate) : ('aiInsights.other' | translate) }}</span>
                      </div>
                    </div>
                    <ng-template #noRegularClass>
                      <div class="insight-main-value-compact">{{ 'aiInsights.notAvailable' | translate }}</div>
                    </ng-template>
                    <div class="insight-description-text">{{ insightMetadata['most_regular_class']?.insightDescription || ('aiInsights.bestPerformingClassDesc' | translate) }}</div>
                  </div>
                </div>

                <div class="insight-card-staggered insight-card-medium insight-excellent-compact">
                  <div class="insight-header-compact">
                    <i class="fa fa-trophy"></i>
                    <span>{{ insightMetadata['best_homework_discipline']?.insightName || ('aiInsights.homeworkLeader' | translate) }}</span>
                    <div class="info-tooltip" 
                         [attr.data-tooltip]="insightMetadata['best_homework_discipline']?.insightDisclaimerMessage || ('aiInsights.homeworkLeaderDesc' | translate)"
                         (mouseenter)="showTooltip($event)"
                         (mouseleave)="hideTooltip($event)">
                      <i class="fa fa-info-circle"></i>
                    </div>
                  </div>
                  <div class="insight-content-compact">
                    <div class="classes-list-container" *ngIf="classWithBestHomeworkDiscipline.length > 0; else noHomeworkDiscipline">
                      <div class="class-item-main" *ngFor="let classItem of classWithBestHomeworkDiscipline.slice(0, 2); let i = index">
                        <div class="insight-main-value-compact">{{ classItem.name }}</div>
                        <div class="insight-metric-compact">
                          <span class="metric-badge">{{ classItem.completion }}%</span>
                          <span class="metric-label-compact">{{ 'aiInsights.studentsAbove90' | translate }}</span>
                        </div>
                      </div>
                      <div class="more-classes-indicator" *ngIf="classWithBestHomeworkDiscipline.length > 2" 
                           [attr.data-count]="classWithBestHomeworkDiscipline.length - 2"
                           (mouseenter)="showClassesTooltip($event, classWithBestHomeworkDiscipline, 'completion')"
                           (mouseleave)="hideClassesTooltip($event)">
                        <span class="more-text">+{{ classWithBestHomeworkDiscipline.length - 2 }} {{ classWithBestHomeworkDiscipline.length - 2 > 1 ? ('aiInsights.others' | translate) : ('aiInsights.other' | translate) }}</span>
                      </div>
                    </div>
                    <ng-template #noHomeworkDiscipline>
                      <div class="insight-main-value-compact">{{ 'aiInsights.notAvailable' | translate }}</div>
                    </ng-template>
                    <div class="insight-description-text">{{ insightMetadata['best_homework_discipline']?.insightDescription || ('aiInsights.homeworkLeaderDesc' | translate) }}</div>
                  </div>
                </div>

                <div class="insight-card-staggered insight-card-medium insight-danger-compact">
                  <div class="insight-header-compact">
                    <i class="fa fa-exclamation-circle"></i>
                    <span>{{ insightMetadata['most_irregular_class']?.insightName || ('aiInsights.needsAttention' | translate) }}</span>
                    <div class="info-tooltip" 
                         [attr.data-tooltip]="insightMetadata['most_irregular_class']?.insightDisclaimerMessage || ('aiInsights.needsAttentionDesc' | translate)"
                         (mouseenter)="showTooltip($event)"
                         (mouseleave)="hideTooltip($event)">
                      <i class="fa fa-info-circle"></i>
                    </div>
                  </div>
                  <div class="insight-content-compact">
                    <div class="classes-list-container" *ngIf="mostIrregularClass.length > 0; else noIrregularClass">
                      <div class="class-item-main" *ngFor="let classItem of mostIrregularClass.slice(0, 2); let i = index">
                        <div class="insight-main-value-compact">{{ classItem.name }}</div>
                        <div class="insight-metric-compact">
                          <span class="metric-badge danger">{{ classItem.attendance }}%</span>
                          <span class="metric-label-compact">{{ 'aiInsights.attendanceLabel' | translate }}</span>
                        </div>
                      </div>
                      <div class="more-classes-indicator" *ngIf="mostIrregularClass.length > 2" 
                           [attr.data-count]="mostIrregularClass.length - 2"
                           (mouseenter)="showClassesTooltip($event, mostIrregularClass, 'attendance')"
                           (mouseleave)="hideClassesTooltip($event)">
                        <span class="more-text">+{{ mostIrregularClass.length - 2 }} {{ mostIrregularClass.length - 2 > 1 ? ('aiInsights.others' | translate) : ('aiInsights.other' | translate) }}</span>
                      </div>
                    </div>
                    <ng-template #noIrregularClass>
                      <div class="insight-main-value-compact">{{ 'aiInsights.notAvailable' | translate }}</div>
                    </ng-template>
                    <div class="insight-description-text">{{ insightMetadata['most_irregular_class']?.insightDescription || ('aiInsights.needsAttentionDesc' | translate) }}</div>
                  </div>
                </div>

                <div class="insight-card-staggered insight-card-small insight-warning-compact">
                  <div class="insight-header-compact">
                    <i class="fa fa-warning"></i>
                    <span>{{ insightMetadata['homework_engagement_risk']?.insightName || ('aiInsights.atRisk' | translate) }}</span>
                    <div class="info-tooltip" 
                         [attr.data-tooltip]="insightMetadata['homework_engagement_risk']?.insightDisclaimerMessage || ('aiInsights.atRiskDesc' | translate)"
                         (mouseenter)="showTooltip($event)"
                         (mouseleave)="hideTooltip($event)">
                      <i class="fa fa-info-circle"></i>
                    </div>
                  </div>
                  <div class="insight-content-compact">
                    <div class="classes-list-container" *ngIf="classWithHomeworkEngagementRisk.length > 0; else noEngagementRisk">
                      <div class="class-item-main" *ngFor="let classItem of classWithHomeworkEngagementRisk.slice(0, 2); let i = index">
                        <div class="insight-main-value-compact">{{ classItem.name }}</div>
                        <div class="insight-metric-compact">
                          <span class="metric-badge warning">{{ classItem.completion }}%</span>
                          <span class="metric-label-compact">{{ 'aiInsights.studentsBelow50' | translate }}</span>
                        </div>
                      </div>
                      <div class="more-classes-indicator" *ngIf="classWithHomeworkEngagementRisk.length > 2" 
                           [attr.data-count]="classWithHomeworkEngagementRisk.length - 2"
                           (mouseenter)="showClassesTooltip($event, classWithHomeworkEngagementRisk, 'completion')"
                           (mouseleave)="hideClassesTooltip($event)">
                        <span class="more-text">+{{ classWithHomeworkEngagementRisk.length - 2 }} {{ classWithHomeworkEngagementRisk.length - 2 > 1 ? ('aiInsights.others' | translate) : ('aiInsights.other' | translate) }}</span>
                      </div>
                    </div>
                    <ng-template #noEngagementRisk>
                      <div class="insight-main-value-compact">{{ 'aiInsights.notAvailable' | translate }}</div>
                    </ng-template>
                    <div class="insight-description-text">{{ insightMetadata['homework_engagement_risk']?.insightDescription || ('aiInsights.atRiskDesc' | translate) }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section 2: Subject & Teacher Performance -->
            <div class="insight-section">
              <div class="section-title-wrapper">
                <h2 class="section-title-main">
                  <i class="fa fa-book"></i>
                  {{ 'aiInsights.subjectTeacherPerformance' | translate }}
                </h2>
                <p class="section-subtitle">{{ 'aiInsights.subjectTeacherSubtitle' | translate }}</p>
              </div>
              
              <!-- Chart Row -- Full Width -->
              <div class="chart-row-wrapper">
                <div class="chart-card-full">
                  <div class="chart-header-compact">
                    <h3>{{ 'aiInsights.subjectPerformance' | translate }}</h3>
                    <div class="chart-info">
                      <i class="fa fa-bar-chart"></i>
                      <div class="info-tooltip" 
                           [attr.data-tooltip]="insightMetadata['subject_attendance_sensitivity']?.insightDisclaimerMessage || ('aiInsights.topPerformingSubjectDesc' | translate)"
                           (mouseenter)="showTooltip($event)"
                           (mouseleave)="hideTooltip($event)">
                        <i class="fa fa-info-circle"></i>
                      </div>
                    </div>
                  </div>
                  <div class="chart-container-compact chart-container-horizontal">
                    <canvas id="subjectPerformanceChart"></canvas>
                  </div>
                </div>
              </div>

              <!-- KPI Cards Row - 2x2 Grid with Unique Style -->
              <div class="kpi-cards-grid">
                <!-- Top Performing Subject Card -->
                <div class="feature-card feature-card-success">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-content">
                    <div class="feature-card-header">
                      <div class="feature-icon-circle feature-icon-success">
                        <i class="fa fa-trophy"></i>
                      </div>
                      <div class="feature-header-text">
                        <div class="feature-header-top">
                          <h3>{{ insightMetadata['top_performing_subject']?.insightName || ('aiInsights.topPerformingSubject' | translate) }}</h3>
                          <div class="info-tooltip" 
                               [attr.data-tooltip]="insightMetadata['top_performing_subject']?.insightDisclaimerMessage || ('aiInsights.topPerformingSubjectDesc' | translate)"
                               (mouseenter)="showTooltip($event)"
                               (mouseleave)="hideTooltip($event)">
                            <i class="fa fa-info-circle"></i>
                          </div>
                        </div>
                        <div class="feature-header-description">{{ insightMetadata['top_performing_subject']?.insightDescription || ('aiInsights.topPerformingSubjectDesc' | translate) }}</div>
                      </div>
                    </div>
                    <div class="feature-card-body" *ngIf="topPerformingSubject.length > 0; else noTopSubject">
                      <div class="feature-items">
                        <div class="feature-item" *ngFor="let subject of topPerformingSubject.slice(0, 2)">
                          <div class="feature-item-content">
                            <span class="feature-item-label">{{ subject.name }}</span>
                            <span class="feature-item-badge feature-badge-success">{{ subject.engagement | number:'1.2-2' }}%</span>
                          </div>
                        </div>
                        <div class="feature-more-btn" *ngIf="topPerformingSubject.length > 2" 
                             (mouseenter)="showClassesTooltip($event, topPerformingSubject, 'engagement')"
                             (mouseleave)="hideClassesTooltip($event)">
                          <i class="fa fa-ellipsis-h"></i>
                          <span>{{ topPerformingSubject.length - 2 }} {{ 'aiInsights.more' | translate }}</span>
                        </div>
                      </div>
                    </div>
                    <ng-template #noTopSubject>
                      <div class="feature-card-body">
                        <div class="feature-empty">{{ 'aiInsights.noDataAvailable' | translate }}</div>
                      </div>
                    </ng-template>
                  </div>
                </div>

                <!-- Most Challenging Subject Card -->
                <div class="feature-card feature-card-danger">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-content">
                    <div class="feature-card-header">
                      <div class="feature-icon-circle feature-icon-danger">
                        <i class="fa fa-exclamation-triangle"></i>
                      </div>
                      <div class="feature-header-text">
                        <div class="feature-header-top">
                          <h3>{{ insightMetadata['most_challenging_subject']?.insightName || ('aiInsights.mostChallengingSubject' | translate) }}</h3>
                          <div class="info-tooltip" 
                               [attr.data-tooltip]="insightMetadata['most_challenging_subject']?.insightDisclaimerMessage || ('aiInsights.mostChallengingSubjectDesc' | translate)"
                               (mouseenter)="showTooltip($event)"
                               (mouseleave)="hideTooltip($event)">
                            <i class="fa fa-info-circle"></i>
                          </div>
                        </div>
                        <div class="feature-header-description">{{ insightMetadata['most_challenging_subject']?.insightDescription || ('aiInsights.mostChallengingSubjectDesc' | translate) }}</div>
                      </div>
                    </div>
                    <div class="feature-card-body" *ngIf="mostChallengingSubject.length > 0; else noChallengingSubject">
                      <div class="feature-items">
                        <div class="feature-item" *ngFor="let subject of mostChallengingSubject.slice(0, 2)">
                          <div class="feature-item-content">
                            <span class="feature-item-label">{{ subject.name }}</span>
                            <span class="feature-item-badge feature-badge-danger">{{ subject.engagement | number:'1.2-2' }}%</span>
                          </div>
                        </div>
                        <div class="feature-more-btn" *ngIf="mostChallengingSubject.length > 2" 
                             (mouseenter)="showClassesTooltip($event, mostChallengingSubject, 'engagement')"
                             (mouseleave)="hideClassesTooltip($event)">
                          <i class="fa fa-ellipsis-h"></i>
                          <span>{{ mostChallengingSubject.length - 2 }} {{ 'aiInsights.more' | translate }}</span>
                        </div>
                      </div>
                    </div>
                    <ng-template #noChallengingSubject>
                      <div class="feature-card-body">
                        <div class="feature-empty">{{ 'aiInsights.noDataAvailable' | translate }}</div>
                      </div>
                    </ng-template>
                  </div>
                </div>

                <!-- Most Engaging Teacher Card -->
                <div class="feature-card feature-card-success">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-content">
                    <div class="feature-card-header">
                      <div class="feature-icon-circle feature-icon-success">
                        <i class="fa fa-users"></i>
                      </div>
                      <div class="feature-header-text">
                        <div class="feature-header-top">
                          <h3>{{ insightMetadata['most_engaging_teacher']?.insightName || ('aiInsights.mostEngagingTeacher' | translate) }}</h3>
                          <div class="info-tooltip" 
                               [attr.data-tooltip]="insightMetadata['most_engaging_teacher']?.insightDisclaimerMessage || ('aiInsights.mostEngagingTeacherDesc' | translate)"
                               (mouseenter)="showTooltip($event)"
                               (mouseleave)="hideTooltip($event)">
                            <i class="fa fa-info-circle"></i>
                          </div>
                        </div>
                        <div class="feature-header-description">{{ insightMetadata['most_engaging_teacher']?.insightDescription || ('aiInsights.mostEngagingTeacherDesc' | translate) }}</div>
                      </div>
                    </div>
                    <div class="feature-card-body" *ngIf="mostEngagingTeacher.length > 0; else noEngagingTeacher">
                      <div class="feature-items">
                        <div class="feature-item" *ngFor="let teacher of mostEngagingTeacher.slice(0, 2)">
                          <div class="feature-item-content">
                            <span class="feature-item-label">{{ teacher.name }}</span>
                            <span class="feature-item-badge feature-badge-success">{{ teacher.completion | number:'1.2-2' }}%</span>
                          </div>
                        </div>
                        <div class="feature-more-btn" *ngIf="mostEngagingTeacher.length > 2" 
                             (mouseenter)="showClassesTooltip($event, mostEngagingTeacher, 'completion')"
                             (mouseleave)="hideClassesTooltip($event)">
                          <i class="fa fa-ellipsis-h"></i>
                          <span>{{ mostEngagingTeacher.length - 2 }} {{ 'aiInsights.more' | translate }}</span>
                        </div>
                      </div>
                    </div>
                    <ng-template #noEngagingTeacher>
                      <div class="feature-card-body">
                        <div class="feature-empty">{{ 'aiInsights.noDataAvailable' | translate }}</div>
                      </div>
                    </ng-template>
                  </div>
                </div>

                <!-- Teacher Support Required Card -->
                <div class="feature-card feature-card-danger">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-content">
                    <div class="feature-card-header">
                      <div class="feature-icon-circle feature-icon-danger">
                        <i class="fa fa-exclamation-circle"></i>
                      </div>
                      <div class="feature-header-text">
                        <div class="feature-header-top">
                          <h3>{{ insightMetadata['teacher_support_required']?.insightName || ('aiInsights.teacherSupportRequired' | translate) }}</h3>
                          <div class="info-tooltip" 
                               [attr.data-tooltip]="insightMetadata['teacher_support_required']?.insightDisclaimerMessage || ('aiInsights.teacherSupportRequiredDesc' | translate)"
                               (mouseenter)="showTooltip($event)"
                               (mouseleave)="hideTooltip($event)">
                            <i class="fa fa-info-circle"></i>
                          </div>
                        </div>
                        <div class="feature-header-description">{{ insightMetadata['teacher_support_required']?.insightDescription || ('aiInsights.teacherSupportRequiredDesc' | translate) }}</div>
                      </div>
                    </div>
                    <div class="feature-card-body" *ngIf="teacherSupportRequired.length > 0; else noTeacherSupport">
                      <div class="feature-items">
                        <div class="feature-item" *ngFor="let teacher of teacherSupportRequired.slice(0, 2)">
                          <div class="feature-item-content">
                            <span class="feature-item-label">{{ teacher.name }}</span>
                            <span class="feature-item-badge feature-badge-danger">{{ teacher.completion | number:'1.2-2' }}%</span>
                          </div>
                        </div>
                        <div class="feature-more-btn" *ngIf="teacherSupportRequired.length > 2" 
                             (mouseenter)="showClassesTooltip($event, teacherSupportRequired, 'completion')"
                             (mouseleave)="hideClassesTooltip($event)">
                          <i class="fa fa-ellipsis-h"></i>
                          <span>{{ teacherSupportRequired.length - 2 }} {{ 'aiInsights.more' | translate }}</span>
                        </div>
                      </div>
                    </div>
                    <ng-template #noTeacherSupport>
                      <div class="feature-card-body">
                        <div class="feature-empty">{{ 'aiInsights.noDataAvailable' | translate }}</div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section 4: Attendance Patterns -->
            <div class="insight-section">
              <div class="section-title-wrapper">
                <h2 class="section-title-main">
                  <i class="fa fa-calendar-alt"></i>
                  {{ 'aiInsights.attendancePatterns' | translate }}
                </h2>
                <p class="section-subtitle">{{ 'aiInsights.attendancePatternsSubtitle' | translate }}</p>
              </div>
              
              <div class="staggered-grid attendance-patterns-grid">
                <div class="attendance-pattern-card pattern-best-card">
                  <div class="pattern-card-header-best">
                    <div class="pattern-header-icon-best">
                      <i class="fa fa-check-circle"></i>
                    </div>
                    <div class="pattern-header-info">
                      <div class="pattern-header-label">{{ insightMetadata['best_attendance_day']?.insightName || ('aiInsights.bestAttendanceDay' | translate) }}</div>
                      <div class="info-tooltip" 
                           [attr.data-tooltip]="insightMetadata['best_attendance_day']?.insightDisclaimerMessage || ('aiInsights.bestAttendanceDayDesc' | translate)"
                           (mouseenter)="showTooltip($event)"
                           (mouseleave)="hideTooltip($event)">
                        <i class="fa fa-info-circle"></i>
                      </div>
                    </div>
                  </div>
                  <div class="pattern-card-body">
                    <div class="pattern-day-display">
                      <div class="pattern-day-value">{{ bestAttendanceDay || ('aiInsights.notAvailable' | translate) }}</div>
                      <div class="pattern-day-badge success-badge">
                        <i class="fa fa-arrow-up"></i>
                        <span>{{ 'aiInsights.peak' | translate }}</span>
                      </div>
                    </div>
                    <div class="pattern-description-text">{{ insightMetadata['best_attendance_day']?.insightDescription || ('aiInsights.bestAttendanceDayDesc' | translate) }}</div>
                  </div>
                </div>

                <div class="attendance-pattern-card pattern-worst-card">
                  <div class="pattern-card-header-worst">
                    <div class="pattern-header-icon-worst">
                      <i class="fa fa-times-circle"></i>
                    </div>
                    <div class="pattern-header-info">
                      <div class="pattern-header-label">{{ insightMetadata['worst_attendance_day']?.insightName || ('aiInsights.worstAttendanceDay' | translate) }}</div>
                      <div class="info-tooltip" 
                           [attr.data-tooltip]="insightMetadata['worst_attendance_day']?.insightDisclaimerMessage || ('aiInsights.worstAttendanceDayDesc' | translate)"
                           (mouseenter)="showTooltip($event)"
                           (mouseleave)="hideTooltip($event)">
                        <i class="fa fa-info-circle"></i>
                      </div>
                    </div>
                  </div>
                  <div class="pattern-card-body">
                    <div class="pattern-day-display">
                      <div class="pattern-day-value">{{ worstAttendanceDay || ('aiInsights.notAvailable' | translate) }}</div>
                      <div class="pattern-day-badge danger-badge">
                        <i class="fa fa-arrow-down"></i>
                        <span>{{ 'aiInsights.low' | translate }}</span>
                      </div>
                    </div>
                    <div class="pattern-description-text">{{ insightMetadata['worst_attendance_day']?.insightDescription || ('aiInsights.worstAttendanceDayDesc' | translate) }}</div>
                  </div>
                </div>

                <div class="attendance-pattern-card pattern-burnout-card">
                  <div class="pattern-card-header-burnout">
                    <div class="pattern-header-icon-burnout">
                      <i class="fa fa-fire"></i>
                    </div>
                    <div class="pattern-header-info">
                      <div class="pattern-header-label">{{ insightMetadata['homework_burnout_risk_day']?.insightName || ('aiInsights.burnoutRiskDay' | translate) }}</div>
                      <div class="info-tooltip" 
                           [attr.data-tooltip]="insightMetadata['homework_burnout_risk_day']?.insightDisclaimerMessage || ('aiInsights.burnoutRiskDayDesc' | translate)"
                           (mouseenter)="showTooltip($event)"
                           (mouseleave)="hideTooltip($event)">
                        <i class="fa fa-info-circle"></i>
                      </div>
                    </div>
                  </div>
                  <div class="pattern-card-body">
                    <div class="pattern-day-display">
                      <div class="pattern-day-value">{{ homeworkBurnoutRiskDay || ('aiInsights.notAvailable' | translate) }}</div>
                      <div class="pattern-day-badge warning-badge">
                        <i class="fa fa-exclamation"></i>
                        <span>{{ 'aiInsights.risk' | translate }}</span>
                      </div>
                    </div>
                    <div class="pattern-description-text">{{ insightMetadata['homework_burnout_risk_day']?.insightDescription || ('aiInsights.burnoutRiskDayDesc' | translate) }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section 5: Risk Analysis -->
            <div class="insight-section">
              <div class="section-title-wrapper">
                <h2 class="section-title-main">
                  <i class="fa fa-exclamation-triangle"></i>
                  {{ insightMetadata['high_risk_subject']?.insightName || ('aiInsights.riskAnalysis' | translate) }}
                </h2>
                <p class="section-subtitle">{{ insightMetadata['high_risk_subject']?.insightDescription || ('aiInsights.riskAnalysisSubtitle' | translate) }}</p>
              </div>
              
              <div class="staggered-grid">
                <div class="risk-section-staggered" *ngIf="highRiskSubjects.length > 0">
                  <div class="risk-grid-modern">
                    <div class="risk-card-modern" *ngFor="let subject of highRiskSubjects">
                      <div class="risk-card-header-modern">
                        <div class="risk-icon-modern">
                          <i class="fa fa-exclamation-triangle"></i>
                        </div>
                        <div class="risk-subject-name-modern">{{ subject.name }}</div>
                        <div class="risk-badge-modern">
                          <span>{{ 'aiInsights.highRisk' | translate }}</span>
                        </div>
                      </div>
                      <div class="risk-card-body-modern">
                        <div class="risk-metrics-modern">
                          <div class="risk-metric-item-modern">
                            <div class="risk-metric-icon attendance-icon">
                              <i class="fa fa-user-check"></i>
                            </div>
                            <div class="risk-metric-content">
                              <div class="risk-metric-label">{{ 'aiInsights.attendanceLabel' | translate }}</div>
                              <div class="risk-metric-value">{{ subject.attendance }}%</div>
                            </div>
                          </div>
                          <div class="risk-metric-item-modern">
                            <div class="risk-metric-icon homework-icon">
                              <i class="fa fa-book"></i>
                            </div>
                            <div class="risk-metric-content">
                              <div class="risk-metric-label">{{ 'aiInsights.homeworkCompletion' | translate }}</div>
                              <div class="risk-metric-value">{{ subject.homework }}%</div>
                            </div>
                          </div>
                        </div>
                        <div class="risk-progress-modern">
                          <div class="risk-progress-label">{{ 'aiInsights.overallRiskScore' | translate }}</div>
                          <div class="risk-progress-bar-wrapper">
                            <div class="risk-progress-bar-modern" [style.width.%]="(subject.attendance + subject.homework) / 2"></div>
                            <span class="risk-progress-value">{{ (subject.attendance + subject.homework) / 2 | number:'1.0-0' }}%</span>
                          </div>
                        </div>
                        <div class="risk-description-modern" *ngIf="subject.classNumber">
                          <i class="fa fa-info-circle"></i>
                          <span>{{ subject.classNumber }}{{ subject.classDivision ? '-' + subject.classDivision : '' }} - {{ 'aiInsights.lowAttendanceHomework' | translate }}</span>
                        </div>
                        <div class="risk-description-modern" *ngIf="!subject.classNumber">
                          <i class="fa fa-info-circle"></i>
                          <span>{{ 'aiInsights.lowAttendanceHomework' | translate }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="risk-empty-staggered" *ngIf="highRiskSubjects.length === 0">
                  <div class="risk-empty-state-modern">
                    <div class="risk-empty-icon">
                      <i class="fa fa-check-circle"></i>
                    </div>
                    <div class="risk-empty-text">{{ 'aiInsights.noHighRiskSubjects' | translate }}</div>
                    <div class="risk-empty-subtext">{{ 'aiInsights.allSubjectsNormal' | translate }}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
</div>
